import styled from "styled-components";
import globalStyles from "../../constants/globalStyles/theme.json";

const { colors, radius, spacing, breakpoints } = globalStyles;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${spacing.space32};
  background-color: ${colors.primary.offWhite};
  border-radius: ${radius.xLarge};
  border: 1px solid ${colors.primary.darkGreen};
  flex-grow: 1;
  flex-shrink: 1;
  min-width: 260px;
  max-width: 400px;
  margin: ${spacing.space16};

  @media (max-width: ${breakpoints.m}) {
    padding: ${spacing.space24};
    margin: 0 ${spacing.space16};
  }
`;

export const RatingContainer = styled.div`
  display: flex;
`;

export const CustomerName = styled.p`
  color: ${colors.primary.darkGreen};
  font-size: 1.25rem;
  font-weight: 700;
  margin-bottom: -${spacing.space4};
`;

export const Testimonial = styled.p`
  color: ${colors.primary.darkGreen};
`;
